const getTemplatesInfo = (state) => state.template.templates
const getTemplateInfo = (state) => state.template.activeTemplate
const getTemplateFieldsInfo = (state) => state.template.templateFields

export default {
  getTemplatesInfo,
  getTemplateInfo,
  getTemplateFieldsInfo,
}
